export function buildDiscoverieAdminViewerHref(
  downloadFileId: number,
  pageNumber?: number
): string | null {
  if (!Number.isInteger(downloadFileId) || downloadFileId <= 0) {
    return null
  }

  const path = `/discoverie/viewer/${downloadFileId}`
  if (!Number.isInteger(pageNumber) || (pageNumber ?? 0) <= 0) {
    return path
  }

  return `${path}?page=${pageNumber}`
}

export function canShowDiscoverieAdminViewer({
  hasRecoverableAdminSession,
  isAdminAuthResolved,
  isAdminAuthenticated,
}: DiscoverieAdminViewerVisibility): boolean {
  return (
    hasRecoverableAdminSession && isAdminAuthResolved && isAdminAuthenticated
  )
}

interface DiscoverieAdminViewerVisibility {
  hasRecoverableAdminSession: boolean
  isAdminAuthResolved: boolean
  isAdminAuthenticated: boolean
}
